import {ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Input, Output,} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'app-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss', '../chip/chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioComponent),
      multi: true,
    },
  ],
})
export class RadioComponent implements ControlValueAccessor {
  @Input() name!: string;
  @Input() value!: number | string | boolean;
  @Input() isLock: boolean = false;
  @Input() chipsMode = false;
  @Input() invalid = false;

  @Output() onChange: EventEmitter<number | string | boolean> = new EventEmitter<
    number | string | boolean
  >();

  private _isChecked: boolean = false;

  private _onChange: (value: any) => void = () => {
  };
  private _onTouched: () => void = () => {
  };

  @Input()
  get checked(): boolean {
    return this._isChecked;
  }

  set checked(value: boolean) {
    this._isChecked = value;
  }

  change() {
    if (!this.isLock) {
      this._isChecked = true;
      this._onChange(this.value);
      this._onTouched();
      this.onChange.emit(this.value);
    }
  }

  writeValue(value: any): void {
    this._isChecked = value === this.value;
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isLock = isDisabled;
  }
}
